import React from 'react'
import { Label } from '@progress/kendo-react-labels'
import './style.css'

const LabelPure = (props) => {
  return (
    <Label className='labels-title'>
      {props.title}
    </Label>
  )
}

export default LabelPure
